import { c as _c } from "react/compiler-runtime";
import { EmailFooterDataListInterface, EmailFooterUpdateInterface } from 'shared/components/dashboard-mail-editor/types/email-footer-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { handle422Error } from 'shared/utils/parse-422-errors';
import { MailingSettingsErrorsInterface } from '../types/mailing-settings-interface';
export const useUpdateEmailFooter = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.put,
      unprocessableContentHandler: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher,
    isFetching
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = async (data, setErrors) => {
      ;
      try {
        return await fetcher("/api/dashboard/mailing-service/email-footer", data);
      } catch (t2) {
        const e = t2;
        handle422Error(e, setErrors);
        throw e;
      }
    };
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isFetching || $[4] !== t1) {
    t2 = {
      fetcher: t1,
      isFetching
    };
    $[3] = isFetching;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
function _temp(error) {
  throw error;
}